// extracted by mini-css-extract-plugin
export var section = "_2i-1";
export var topNav = "_2i-0";